'use strict';

/*@ngInject*/
module.exports = function () {
	return {
		scope: {
			objects: '=',
			mapObjects: '=',
			isCategoryFilterEmpty: '<'
		},
		bindToController: true,
		controllerAs: 'vm',
		/*@ngInject*/
		controller: function controller($scope, mapService, $sce, $rootScope, $uibModal, publicObjectsService) {
			var vm = this;
			vm.mapLoaded = false;
			vm.mapUrlsLoaded = false;
			vm.objectDataModalOpen = false;
			vm.isCategoryFilterEmpty = true;
			vm.selectedObject = {};
			vm.url = '';
			vm.mapSource = '';
			vm.rootscope = $rootScope;

			vm.objectUrl = '';
			vm.roadElementPathUrl = '';
			vm.roadElementObstacleUrl = '';
			vm.routeUrl = '';
			vm.busStopUrl = '';

			$scope.$watch(function () {
				return vm.mapObjects;
			}, function (val) {
				if (vm.mapLoaded && vm.mapObjects) {

					if (!_.get(vm.mapObjects, 'length') || _.some(vm.mapObjects, function (x) {
						return !x.isTransport;
					})) {
						vm.resetVisibilityRange(vm.busStopUrl);
					} else {
						vm.removeVisibilityRange(vm.busStopUrl);
					}

					vm.removeFilters();

					vm.postFilter(vm.getGisIdsFromObjects(), vm.objectUrl);

					if (!_.get(vm.objects, 'length') || _.some(vm.mapObjects, function (x) {
						return x.isTransport;
					})) {
						vm.postFilter(vm.getGisIdsFromObjects(), vm.busStopUrl);
					}

					if (vm.isCategoryFilterEmpty || _.some(vm.mapObjects, function (x) {
						return x.isTransport;
					})) {
						vm.postMessage({ type: 'show-layers', url: vm.busStopUrl });
					} else if (!_.some(vm.mapObjects, function (x) {
						return x.isTransport;
					}) && !vm.isCategoryFilterEmpty) {
						vm.postMessage({ type: 'hide-layers', url: vm.busStopUrl });
					}
				}
			});

			vm.$onInit = function () {
				var mapUrls = vm.rootscope.mapUrls;

				vm.objectUrl = mapUrls.objectUrl;
				vm.roadElementPathUrl = mapUrls.roadElementPathUrl;
				vm.roadElementObstacleUrl = mapUrls.roadElementObstacleUrl;
				vm.routeUrl = mapUrls.routeUrl;
				vm.busStopUrl = mapUrls.busStopUrl;
				vm.akisUrl = mapUrls.akisUrl;
				vm.opisUrl = mapUrls.opisUrl;

				var hideUrls = vm.routeUrl + ',' + vm.roadElementObstacleUrl + ',' + vm.roadElementPathUrl;
				vm.mapSource = mapUrls.mapUrl;
				vm.url = $sce.trustAsResourceUrl(vm.mapSource + '?init=[{"type":"filter","ids":[],"url":' + JSON.stringify(vm.objectUrl) + ',"zoomTo":false},{"type":"hide-layers","url":' + JSON.stringify(hideUrls) + '}]');
				vm.mapUrlsLoaded = true;
			};

			var unsub = mapService.subscribe(function (data) {
				if (data.type === 'ready') {
					vm.mapLoaded = true;
					if (vm.mapObjects) {
						vm.postFilter(vm.getGisIdsFromObjects(), vm.objectUrl);
						vm.enableIdentify();
					}
				}

				if (data.url && data.type === 'identify-result') {
					if (data.url.includes(vm.opisUrl) || data.url.includes(vm.akisUrl)) {
						vm.rootscope.openAkisOpisModal(data);
					} else if (vm.mapObjects) {
						angular.forEach(vm.mapObjects, function (object) {
							if (object.gis_id === data.id) {
								vm.openObjectModal(object);
							}
						});
					}
				}
			});

			vm.openObjectModal = function (object) {
				var objectsFilter = JSON.parse(localStorage.getItem('objectsFilter')).filter;
				objectsFilter.objectId = object.id;
				publicObjectsService.getObjectsBySearch(objectsFilter, null).then(function (result) {
					$uibModal.open({
						template: require('./object-data-modal.html'),
						controller: require('./object-data-modal.directive'),
						controllerAs: 'vm',
						size: 'lg',
						backdrop: 'static',
						keyboard: false,
						windowClass: 'center-modal',
						resolve: {
							object: function object() {
								return result.data[0];
							}
						}
					});
					vm.rootscope.isModalOpen = true;
				});
			};

			$scope.$on('$destroy', function () {
				return unsub();
			});

			vm.getGisIdsFromObjects = function () {
				var gis_ids = [];
				angular.forEach(vm.mapObjects, function (object) {
					gis_ids.push(object.gis_id);
				});
				return gis_ids;
			};

			vm.postFilter = function (ids, url) {
				vm.postMessage({ type: 'filter', ids: ids, url: url, zoomTo: false });
			};

			vm.removeFilters = function () {
				vm.postMessage({ type: 'remove-filter' });
			};

			vm.removeVisibilityRange = function (url) {
				vm.postMessage({ type: 'remove-visibility-range', url: url });
			};

			vm.resetVisibilityRange = function (url) {
				vm.postMessage({ type: 'reset-visibility-range', url: url });
			};

			vm.enableIdentify = function () {
				vm.postMessage({ type: 'enable-identify', url: vm.objectUrl + ',' + vm.busStopUrl + ',' + vm.akisUrl + ',' + vm.opisUrl });
			};

			vm.postMessage = function (message) {
				console.log(message.ids);
				return document.getElementById('mapFrame').contentWindow.postMessage(message, vm.mapSource);
			};
		},
		template: require('./object-results-mapview.directive.html')
	};
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/object-results-mapview.directive.js
 **/